import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { NotificationService } from "./core/services/Notification/notification.service";

@Injectable({
  providedIn: "root",
})
export class SuperAdminService {
  baseUrl = `${environment.domain}`;
  userSessionData;
  constructor(
    private toastr: ToastrService,
    private http: HttpClient,
    private router: Router,
    private notification: NotificationService,
  ) { }
  // this.userSessionData = JSON.parse(sessionStorage.getItem('userSession'));
  getHeader(): HttpHeaders {
    const token = sessionStorage.getItem("token") || "null";
    if (token == "null") {
      // this.toastr.error(res.message);
      this.notification.error("Session Expired");
      window.sessionStorage.clear();
      this.router.navigateByUrl("superAuth/login");
    }
    let headers = new HttpHeaders({
      authorization: `Bearer ${token}`,
    });
    return headers;
  }

  getshippingid(): any {
    throw new Error("Method not implemented.");
  }

  deleteDailogBox(): any {
    if (confirm("Are you sure you want delete?") == true) {
      return true;
    } else {
      return false;
    }
  }

  sortData(): any {
    throw new Error("method not implemented.");
  }

  signIn({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/auth/signIn`;

    return this.http.post<{ status: any; message: any }>(url, { form }).pipe(
      tap({
        next: (val: { status: any; message: any }) => { },
        error: (error) => { },
        complete: () => { },
      }),
    );
  }

  forgotPassword({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/auth/forgotPassword`; // make sure route matches backend

    return this.http.post<{ status: any; message: any }>(url, { form }).pipe(
      tap({
        next: (val) => {
          // optional: you can handle any side-effects here
        },
        error: (err) => { },
      }),
      catchError((err) => {
        // handle HTTP errors gracefully
        this.toastr.error(
          "Something went wrong while sending reset link",
          "Error",
        );
        return of({ status: false, message: "Error sending reset link" });
      }),
    );
  }
  // resetPassword(data: any) {
  //   // http://localhost:4200/superAuth/reset-Password
  //   return this.http.post('http://localhost:3000/auth/reset-password', data);
  // }

  // 🔹 Reset Password API
  resetPassword(data: any) {
    const url = `${environment.domain}/auth/reset-password`;
    return this.http.post<{ status: boolean; message: string }>(url, data).pipe(
      catchError(() => {
        this.toastr.error(
          "Something went wrong while resetting password",
          "Error",
        );
        return of({ status: false, message: "Error resetting password" });
      }),
    );
  }
  // 🔹 Validate Reset Token API
  validateResetToken(token: string) {
    const url = `${environment.domain}/auth/validate-reset-token`;
    return this.http
      .post<{ status: boolean; message: string; email?: string }>(url, {
        token,
      })
      .pipe(
        catchError(() => {
          this.toastr.error("Token validation failed", "Error");
          return of({ status: false, message: "Invalid or expired token" });
        }),
      );
  }

  getUsers(
    page: number = 1,
    limit: number = 10,
    search: string = "",
  ): Observable<{ status: any; message: any; data: any; pagination: any }> {
    const url = `${environment.domain}/auth/getusers`;
    const option = { headers: this.getHeader() };

    // Build query parameters dynamically
    const params: any = {
      page: page.toString(),
      limit: limit.toString(),
    };

    if (search && search.trim() !== "") {
      params.search = search.trim();
    }

    return this.http
      .get<{ status: any; message: any; data: any; pagination: any }>(url, {
        ...option,
        params,
      })
      .pipe(
        tap({
          next: (res) => {
            // Optional: Debug log
            // console.log('Fetched users:', res);
          },
          error: (error) => { },
        }),
      );
  }

  getAllUsers(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/auth/getallusers`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getSingleUsers({
    form,
  }): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/auth/getSingleUser`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any; data: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  changePassword({
    form,
  }): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/auth/changePassword`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any; data: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createUser({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/auth/createuser`;
    let option = { headers: this.getHeader() };
    // console.log("option", option);

    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateuser({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/auth/updateuser`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  editSingleUser({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/auth/editSingleUser`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deleteuser(email): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/auth/deleteuser`;
    let option = { headers: this.getHeader() };
    // console.log("email", email);

    return this.http
      .post<{ status: any; message: any }>(url, { email }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getlrs(
    page: number = 1,
    limit: number = 1000000,
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ): Observable<any> {
    let url = `${environment.domain
      }/lr/getlrs?page=${page}&limit=${limit}&search=${encodeURIComponent(
        search,
      )}`;

    if (fromDate) url += `&fromDate=${fromDate}`;
    if (toDate) url += `&toDate=${toDate}`;

    return this.http.get(url, { headers: this.getHeader() });
  }

  getLrsBySupervisor(
    page: number = 1,
    limit: number = 1000000,
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ): Observable<{ status: any; message: any; data: any; pagination?: any }> {
    let url = `${environment.domain
      }/lr/getlrsbysupervisor?page=${page}&limit=${limit}&search=${encodeURIComponent(
        search,
      )}`;
    if (fromDate) url += `&fromDate=${fromDate}`;
    if (toDate) url += `&toDate=${toDate}`;

    const options = { headers: this.getHeader() };

    return this.http
      .get<{
        status: any;
        message: any;
        data: any;
        pagination?: any;
      }>(url, options)
      .pipe(
        tap({
          next: () => { },
          error: () => { },
          complete: () => { },
        }),
      );
  }

  getTrackerById(
    trackerId: string,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/lr/tracker/${trackerId}`; // dynamically insert ID
    const options = { headers: this.getHeader() };

    return this.http
      .get<{ status: any; message: any; data: any }>(url, options)
      .pipe(
        tap({
          next: (val) => console.log("Tracker fetched", val),
          error: (err) => console.error("Error fetching tracker", err),
          complete: () => console.log("Request complete"),
        }),
      );
  }

  getTracker(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/lr/trackers`;
    const options = { headers: this.getHeader() };

    return this.http
      .get<{ status: any; message: any; data: any }>(url, options)
      .pipe(
        tap({
          next: (val) => console.log("Trackers fetched:", val),
          error: (err) => console.error("Error fetching trackers:", err),
        }),
      );
  }

  // pagination, limit, search, fromDate, toDate
  getTrackers(
    page: number = 1,
    limit: number = 10,
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ): Observable<{ status: any; message: any; data: any; pagination?: any }> {
    // Base URL
    let url = `${environment.domain
      }/lr/allTrackers?page=${page}&limit=${limit}&search=${encodeURIComponent(
        search,
      )}`;

    // Add date filters if present
    if (fromDate) url += `&fromDate=${fromDate}`;
    if (toDate) url += `&toDate=${toDate}`;

    const options = { headers: this.getHeader() };

    return this.http
      .get<{
        status: any;
        message: any;
        data: any;
        pagination?: any;
      }>(url, options)
      .pipe(
        tap({
          next: (val) => console.log("Trackers fetched:", val),
          error: (err) => console.error("Error fetching trackers:", err),
        }),
      );
  }

  getTrackersBySupervisor(
    supervisorId: string,
    page: number = 1,
    limit: number = 10,
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ): Observable<{ status: any; message: any; data: any; pagination?: any }> {
    let url = `${environment.domain
      }/lr/trackers/supervisor/${supervisorId}?page=${page}&limit=${limit}&search=${encodeURIComponent(
        search,
      )}`;

    // Date filters
    if (fromDate) url += `&fromDate=${fromDate}`;
    if (toDate) url += `&toDate=${toDate}`;

    const options = { headers: this.getHeader() };

    return this.http
      .get<{
        status: any;
        message: any;
        data: any;
        pagination?: any;
      }>(url, options)
      .pipe(
        tap({
          next: (val) =>
            console.log(`Supervisor ${supervisorId} trackers fetched:`, val),
          error: (err) =>
            console.error("Error fetching supervisor trackers:", err),
        }),
      );
  }

  getlrsbyClientId(
    clientId,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/lr/getlrsbyClientId`;
    let option = { headers: this.getHeader() };
    // console.log("hey", option);
    return this.http
      .post<{ status: any; message: any; data: any }>(url, { clientId }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getlrsbyTripId(TripID): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/lr/getlrsByTripId`;
    let option = { headers: this.getHeader() };
    // console.log("hey", option);
    return this.http
      .post<{ status: any; message: any; data: any }>(url, { TripID }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createLR(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/lr/createLR`;
    let option = { headers: this.getHeader() };
    // console.log("hey", option)
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createTracker(
    formData: FormData,
  ): Observable<{ status: any; message: any; data?: any }> {
    const url = `${environment.domain}/lr/createTracker`;
    const option = { headers: this.getHeader() };

    return this.http
      .post<{ status: any; message: any; data?: any }>(url, formData, option)
      .pipe(
        tap({
          next: (res) => {
            // console.log("Tracker created successfully:", res);
          },
          error: (err) => {
            console.error("Error creating tracker:", err);
          },
          complete: () => { },
        }),
      );
  }

  addInvoice(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/lr/addInvoice`;
    let option = { headers: this.getHeader() };
    // console.log("hey", option);
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  updateInvoice(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/lr/updateInvoice`;
    let option = { headers: this.getHeader() };
    // console.log("hey------", option);
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateChallanDetails(form): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/challan/updateChallanDetails`;
    let option = { headers: this.getHeader() };
    // console.log("hey", option);
    return this.http
      .post<{ status: any; message: any }>(url, form, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateFuel(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/fuel/updateFuel`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateChallan(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/challan/updateChallan`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateVehicleFuel(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/fuel/updateVehicleFuel`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  deleteInvoice(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/invoice/deleteInvoice`;
    let option = { headers: this.getHeader() };

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  updateLR({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/lr/updateLR`;
    let option = { headers: this.getHeader() };
    // console.log("hey", option);
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateLRManualCharges(
    id: string,
    data: any
  ): Observable<{ status: any; message: any; data?: any }> {
    const url = `${environment.domain}/lr/updateLR/${id}`;
    let option = { headers: this.getHeader() };
    return this.http.post<{ status: any; message: any; data?: any }>(url, data, option);
  }

  updateTracker(
    trackerData: any,
  ): Observable<{ status: any; message: any; data?: any }> {
    const url = `${environment.domain}/lr/updateTracker`;
    const options = { headers: this.getHeader() };

    // console.log("Updating tracker:", trackerData);

    return this.http
      .post<{
        status: any;
        message: any;
        data?: any;
      }>(url, trackerData, options)
      .pipe(
        tap({
          next: (res) => {
            // console.log("Tracker update response:", res);
          },
          error: (err) => {
            // console.error("Error updating tracker:", err);
          },
        }),
      );
  }
  updatePOD({ form }): Observable<{ status: any; message: any }> {
    // debugger;
    const url = `${environment.domain}/lr/updatePOD`;
    let option = { headers: this.getHeader() };
    // console.log("hey there", option);
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  particlarLR(id: any): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/lr/particlarLR/` + id;
    let option = { headers: this.getHeader() };
    // console.log("hey", option);
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  particlarTracker(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/lr/particularTracker/` + id;
    let option = { headers: this.getHeader() };
    // console.log("hey", option);
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getvehicles(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/lr/getvehicles`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getCompanyName(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageExpense/getcompany`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getSuperVisorName(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageExpense/getSuperVisor`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createDispense({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpense/createDispense`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getDispense(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageExpense/getDispense`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deleteDispense(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpense/deleteDispense`;

    let option = { headers: this.getHeader() };
    // console.log("email", _id);

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getParticularDispense(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageExpense/particlarDispense/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateDispense({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpense/updateDispense`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getVehicleType(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageVehicle/getVehicleType`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getVehiclePermit(
    no: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageVehicle/getVehiclePermit/` + no;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getDriverName(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageVehicle/getDriverName`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  addVehicle(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageVehicle/addVehicle`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getVehicle(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageVehicle/getVehicle`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getVehicleFiltered(params: any): Observable<{
    status: any;
    message: any;
    data: any;
    pagination: any;
  }> {
    const url = `${environment.domain}/manageVehicle/getVehicleFiltered`;

    return this.http.get<{
      status: any;
      message: any;
      data: any;
      pagination: any;
    }>(url, {
      headers: this.getHeader(),
      params,
    });
  }

  deleteVehicle(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageVehicle/deleteVehicle`;
    let option = { headers: this.getHeader() };
    // console.log("email", _id);

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getparticlarVehicle(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageVehicle/particlarVehicle/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateVehicle(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageVehicle/updateVehicle`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  addDriver(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageDriver/addDriver`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getDrivers(
    page: number = 1,
    limit: number = 10,
    search: string = "",
  ): Observable<{ status: any; message: any; data: any; pagination?: any }> {
    const url = `${environment.domain}/manageDriver/getDriver`;

    // Construct query params
    const params = new HttpParams()
      .set("page", page.toString())
      .set("limit", limit.toString())
      .set("search", search);

    const options = {
      headers: this.getHeader(),
      params,
    };

    return this.http
      .get<{
        status: any;
        message: any;
        data: any;
        pagination?: any;
      }>(url, options)
      .pipe(
        tap({
          next: (val) => {
            // add logging or toast notifications  if needed
          },
          error: (error) => {
            console.error("Error fetching drivers:", error);
          },
        }),
      );
  }

  getTripIDs(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/lr/getTripIDs`;

    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  deleteDriver(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageDriver/deleteDriver`;
    let option = { headers: this.getHeader() };
    //console.log("email", _id)

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getparticlarDriver(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageDriver/particlarDriver/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateDriver(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageDriver/updateDriver`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  createClient({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageClient/addClient`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getClient(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageClient/getClient`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  deleteClient(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageClient/deleteClient`;
    let option = { headers: this.getHeader() };
    //console.log("email", _id)

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getParticularClient(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/manageClient/particlarClient/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  updateClient({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageClient/updateClient`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createshippingparties({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageshippingparties/addshippingparty`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  addHireVehicleFlat(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpenseLog/addHireVehicleFlat`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  // addTollFiles(formData): Observable<{ status: any, message: any }> {
  //   const url = `${environment.domain}/lr/addTollFiles`;
  //   let option = { headers: this.getHeader() }
  //   return this.http.post<{ status: any, message: any }>(url, formData, option)
  //     .pipe(
  //       tap({
  //         next: (val: { status: any, message: any }) => {
  //         },
  //         error: error => {
  //         },
  //         complete: () => {
  //         }
  //       })
  //     );
  // }
  addTollFiles(
    formData: FormData,
  ): Observable<{ status: any; message: any; rawdata: string[] }> {
    const url = `${environment.domain}/lr/addTollFiles`;
    const option = { headers: this.getHeader() };
    return this.http.post<{ status: any; message: any; rawdata: string[] }>(
      url,
      formData,
      option,
    );
  }

  addloadingSlips(
    formData: FormData,
  ): Observable<{ rawdata: any[]; status: any; message: any }> {
    const url = `${environment.domain}/lr/addloadingSlips`;

    // console.log("📤 Sending Loading Slips:", formData);

    return this.http
      .post<{ rawdata: any[]; status: any; message: any }>(url, formData)
      .pipe(
        tap({
          next: (res) => console.log("✅ Upload success:", res),
          error: (err) => console.error("❌ Upload error:", err),
        }),
      );
  }

  addloadingSlipsBack(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/lr/addloadingSlipsBack`;
    // let option = { headers: this.getHeader() }
    // console.log("loading Slipsss&&&", formData);
    return this.http.post<{ status: any; message: any }>(url, formData).pipe(
      tap({
        next: (val: { status: any; message: any }) => { },
        error: (error) => { },
        complete: () => { },
      }),
    );
  }
  addHireVehicleMonthly(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpenseLog/addHireVehicleMonthly`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  addOfficeExpense(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpenseLog/addOfficeExpense`;
    let option = { headers: this.getHeader() };
    return this.http.post<{ status: any; message: any }>(url, formData).pipe(
      tap({
        next: (val: { status: any; message: any }) => { },
        error: (error) => { },
        complete: () => { },
      }),
    );
  }
  addVicheleMaintenance(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpenseLog/addVicheleMaintenance`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  addOwnVicheleMaintenance(
    formData,
  ): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpenseLog/addOwnVicheleMaintenance`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  sendEmail(id: any, binary: any) {
    let option = { headers: this.getHeader() };
    return this.http.post(
      this.baseUrl + "/lr/sendEmail/" + id,
      { binary },
      option,
    );
  }

  getClientList() {
    let option = { headers: this.getHeader() };
    return this.http.get(this.baseUrl + "/manageClient/getClient", option);
  }

  filterData({ form }): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/lr/filterData`;

    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getlrForSupervisor(ClientList: any) {
    let option = { headers: this.getHeader() };
    return this.http.post(
      this.baseUrl + "/lr/getlrForSupervisor/",
      { ClientList },
      option,
    );
  }
  getAllDispense() {
    let option = { headers: this.getHeader() };
    return this.http.get(this.baseUrl + "/mydashboard/getDispense", option);
  }
  getDispenseBySupervisorMonthWiseByYear(year: number, month: number) {
    const option = {
      headers: this.getHeader(),
      params: {
        year: year,
        month: month,
      },
    };

    return this.http.get(
      this.baseUrl + "/mydashboard/getDispenseBySupervisorMonthWiseByYear",
      option,
    );
  }

  getDispenseGroup() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/manageExpense/getDispenseGroup",
      option,
    );
  }
  getAllExpense() {
    let option = { headers: this.getHeader() };
    return this.http.get(this.baseUrl + "/mydashboard/getExpense", option);
  }
  getSummary(year: number) {
    const option = { headers: this.getHeader() };
    return this.http.get(
      `${this.baseUrl}/mydashboard/v2/getSummary/${year}`,
      option,
    );
  }
  getLRExpenseMonthWise(type: "LR" | "Tracker" = "LR") {
    return this.http.get(
      this.baseUrl + "/mydashboard/v2/getLRExpenseMonthWise",
      {
        headers: this.getHeader(),
        params: { type },
      },
    );
  }

  getTripExpenseMonthWise() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/mydashboard/getTripExpenseMonthWise",
      option,
    );
  }

  getVehicleExpenseMonthWise() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/mydashboard/getVehicleExpenseMonthWise",
      option,
    );
  }
  getDispenseMonthWise() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/mydashboard/getDispenseMonthWise",
      option,
    );
  }
  getTripDispenseMonthWise() {
    let option = { headers: this.getHeader() };
    return this.http.get(this.baseUrl + "/mydashboard/getTripDispense", option);
  }
  getExpenseMonthWise() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/mydashboard/getExpenseMonthWise",
      option,
    );
  }
  getLRExpenseParticularMonth(type: string = "LR") {
    return this.http.get(
      `${this.baseUrl}/mydashboard/v2/getLRExpenseParticularMonth?type=${type}`,
      { headers: this.getHeader() },
    );
  }

  getTripIDExpenseParticularMonth() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/mydashboard/getTripIDExpenseParticularMonth",
      option,
    );
  }

  getVehicleExpenseParticularMonth() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/mydashboard/getVehicleExpenseParticularMonth",
      option,
    );
  }

  getMasterData() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/manageExpenseLog/getMasterData",
      option,
    );
  }
  getMasterDataGroup() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/manageExpenseLog/getMasterDataGroup",
      option,
    );
  }
  getMasterDataCategoryGroup() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/manageExpenseLog/getMasterDataCategoryGroup",
      option,
    );
  }
  getMasterDataSubCategoryGroup() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      this.baseUrl + "/manageExpenseLog/getMasterDataSubCategoryGroup",
      option,
    );
  }
  deleteExpense(_id): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/manageExpenseLog/deleteExpense`;
    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getParticularExpense(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/manageExpenseLog/particlarExpense/` + id;
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateOfficeExpence(formData): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/manageExpenseLog/updateOfficeExpence`;

    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  updateVehicleMaintence(formData): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/manageExpenseLog/updateVehicleMaintence`;

    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  getInvoiceTypes() {
    let option = { headers: this.getHeader() };
    return this.http.get(this.baseUrl + "/invoice/getInvoiceType", option);
  }
  getInvoice() {
    let option = { headers: this.getHeader() };
    return this.http.get(this.baseUrl + "/invoice/getInvoiceNew", option);
  }
  getParticularInvoice(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/invoice/getInvoiceByID/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  generateInvoice({ form }): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/invoice/generateInvoice`;

    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }


  generateInvoicePreview({ form }): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/invoice/generateInvoice-preview`;

    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  generateTrackerInvoice(form: {
    clientId: string;
    invoiceType: string;
    trackerNos: string[];
  }): Observable<{ status: boolean; message: string }> {
    const url = `${environment.domain}/invoice/generateTrackerInvoice`;
    const options = { headers: this.getHeader() };

    return this.http.post<{ status: boolean; message: string }>(
      url,
      { form },
      options,
    );
  }


  generateTrackerInvoicePreview(form: {
    clientId: string;
    invoiceType: string;
    trackerNos: string[];
  }): Observable<{ status: boolean; message: string, data: any }> {
    const url = `${environment.domain}/invoice/generateTrackerInvoice-preview`;
    const options = { headers: this.getHeader() };

    return this.http.post<{ status: boolean; message: string, data: any }>(
      url,
      { form },
      options,
    );
  }


  getTrackerInvoiceNew(): Observable<{
    status: boolean;
    message: string;
    data: any[];
  }> {
    const url = `${environment.domain}/invoice/getTrackerInvoiceNew`;
    const options = { headers: this.getHeader() };

    return this.http
      .get<{ status: boolean; message: string; data: any[] }>(url, options)
      .pipe(
        tap({
          next: () => { },
          error: () => { },
          complete: () => { },
        }),
      );
  }

  getTrackersByClientId(clientId: string): Observable<{
    status: boolean;
    message: string;
    data: any[];
  }> {
    const url = `${environment.domain}/lr/getTrackersByClientId`;
    const options = { headers: this.getHeader() };

    return this.http
      .post<{
        status: boolean;
        message: string;
        data: any[];
      }>(url, { clientId }, options)
      .pipe(
        tap({
          next: () => { },
          error: () => { },
          complete: () => { },
        }),
      );
  }

  generateInvoixeUsingTripID({
    form,
  }): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/lr/createInvoiceUsingTripID`;

    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  sendInvoice(id: any, binary: any) {
    let option = { headers: this.getHeader() };
    return this.http.post(
      this.baseUrl + "/lr/sendInvoice/" + id,
      { binary },
      option,
    );
  }
  getSubCategory() {
    let option = { headers: this.getHeader() };
    return this.http.get(
      `${environment.domain}/manageExpenseLog/getSubCategory`,
      option,
    );
  }

  getAllShippingParties(): Observable<{
    status: any;
    message: any;
    data: any;
  }> {
    let option = { headers: this.getHeader() };
    // console.log("option", option);
    const url = `${environment.domain}/manageshippingparties/getAllShippingParties`;
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deleteshippingparty(email): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageshippingparties/deleteshippingparty`;
    let option = { headers: this.getHeader() };
    // console.log("email");

    return this.http
      .post<{ status: any; message: any }>(url, { email }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getparticularshippingparty(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url =
      `${environment.domain}/manageshippingparties/particularshippingparty/` +
      id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  editshippingparty({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageshippingparties/editshippingparty`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createloadingslip({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/loadingSlip/createloadingslip`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getAllloadingslip(): Observable<{ status: any; message: any; data: any }> {
    let option = { headers: this.getHeader() };
    // console.log("option", option);
    const url = `${environment.domain}/loadingSlip/getAllloadingslip`;
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getLoadingSlips(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/loadingSlip/getLoadingSlips`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  editloadingSlip({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/loadingSlip/updateloadingslip`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deleteloadingSlip(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/loadingSlip/deleteloadingSlip`;
    let option = { headers: this.getHeader() };
    // console.log("_id");

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deleteChallan(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/challan/deleteChallan`;
    let option = { headers: this.getHeader() };
    // console.log("_id");

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  // deleteExpense(_id): Observable<{ status: any, message: any }> {
  //   let option = { headers: this.getHeader() }
  //   const url = `${environment.domain}/manageExpenseLog/deleteExpense`;
  //   return this.http.post<{ status: any, message: any }>(url, { _id }, option)
  //     .pipe(
  //       tap({
  //         next: (val: { status: any, message: any }) => {
  //         },
  //         error: error => {
  //         },
  //         complete: () => {
  //         }
  //       })
  //     );
  // }

  getExpense(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/loadingslip/getExpense`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  addExpense({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/loadingslip/addExpense`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  uploadPOD(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/loadingslip/uploadLS`;
    // let option = { headers: this.getHeader() }
    return this.http.post<{ status: any; message: any }>(url, formData).pipe(
      tap({
        next: (val: { status: any; message: any }) => { },
        error: (error) => { },
        complete: () => { },
      }),
    );
  }

  updatePODs(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/loadingslip/updatePODs`;
    // let option = { headers: this.getHeader() }
    return this.http.post<{ status: any; message: any }>(url, formData).pipe(
      tap({
        next: (val: { status: any; message: any }) => { },
        error: (error) => { },
        complete: () => { },
      }),
    );
  }

  getPOD(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/loadingSlip/getPOD`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getparticularloadingslip(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url =
      `${environment.domain}/loadingSlip/getparticularloadingslip/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateloadingslip(formData): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/loadingslip/updateloadingslip`;

    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getparticularChallan(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/challan/getparticularChallan/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getParticularRateChart(
    id: any,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/lr/getParticularRateChart/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createChalan({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/challan/createChallan`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createRateChart({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/lr/rateChart`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createfuel({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/fuel/createFuel`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  addNewPayment({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/fuel/addnewpayment`;
    const option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  addVehicleFuel({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/fuel/createVehicleFuel`;
    const option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getChallan() {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/challan/getchallan`;
    return this.http.get(url, option);
  }

  getvehicleFuel() {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/fuel/getVhicleFuel`;
    return this.http.get(url, option);
  }

  getParticularVehicleFuel(id: any) {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/fuel/getParticularVehicleFuel/` + id;
    return this.http.get(url, option);
  }

  getParticularFuel(id: any) {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/fuel/getParticularFuel/` + id;
    return this.http.get(url, option);
  }

  getFuel() {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/fuel/getfuel`;
    return this.http.get(url, option);
  }

  getRateChart() {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/lr/getRateChart`;
    return this.http.get(url, option);
  }

  findByPlace(formData): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/lr/findByPlace`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, formData, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deleteRateChart(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/lr/deleteRateChart`;
    let option = { headers: this.getHeader() };
    // console.log("_id");

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  createtyreinventory({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/tyreinventory/addtyreinventory`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  gettyreinventory(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/tyreinventory/gettyreinventory`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deletetyreinventory(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/tyreinventory/deletetyreinventory/`;
    let option = { headers: this.getHeader() };
    //console.log("_id");

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getparticulartyreinventory(
    id,
  ): Observable<{ status: any; message: any; data: any }> {
    const url =
      `${environment.domain}/tyreinventory/getparticulartyreinventory/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateTyreInventory(form): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/tyreinventory/updateTyreInventory`;

    return this.http
      .post<{ status: any; message: any }>(url, form, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  addtyreissue({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/tyreissue/addtyreissue`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  gettyreissue(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/tyreissue/gettyreissue`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deletetyreissue(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/tyreissue/deletetyreissue/`;
    let option = { headers: this.getHeader() };
    //console.log("_id");

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getparticulartyreissue(
    id,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/tyreissue/getparticulartyreissue/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateTyreIssue(form): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/tyreissue/updateTyreIssue`;

    return this.http
      .post<{ status: any; message: any }>(url, form, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  addTyreOutEntry({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/tyreoutentry/addtyreoutentry`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  gettyreoutentry(): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/tyreoutentry/gettyreoutentry`;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deletetyreoutentry(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/tyreoutentry/deletetyreoutentry`;
    let option = { headers: this.getHeader() };
    //console.log("_id");

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getparticulartyreoutentry(
    id,
  ): Observable<{ status: any; message: any; data: any }> {
    const url =
      `${environment.domain}/tyreoutentry/getparticulartyreoutentry/` + id;
    let option = { headers: this.getHeader() };
    return this.http
      .get<{ status: any; message: any; data: any }>(url, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any; data: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  updateTyreOutInventory(form): Observable<{ status: any; message: any }> {
    let option = { headers: this.getHeader() };
    const url = `${environment.domain}/tyreoutentry/updateTyreOutInventory`;

    return this.http
      .post<{ status: any; message: any }>(url, form, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deleteexpenses(_id: any): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/loadingSlip/deleteexpenses/`;
    let option = { headers: this.getHeader() };
    //console.log("_id");

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getAllExpensesAdmin(
    page: number = 1,
    limit: number = 150,
    search: string = "",
    fromDate?: string,
    toDate?: string,
  ): Observable<{ status: any; message: any; data: any; pagination: any }> {
    const url = `${environment.domain}/manageExpense/getAllExpensesAdmin`;

    let params = new HttpParams()
      .set("page", page.toString())
      .set("limit", limit.toString());

    if (search) {
      params = params.set("search", search);
    }

    if (fromDate) {
      params = params.set("fromDate", fromDate);
    }

    if (toDate) {
      params = params.set("toDate", toDate);
    }

    const options = {
      headers: this.getHeader(),
      params,
    };

    return this.http
      .get<{
        status: any;
        message: any;
        data: any;
        pagination: any;
      }>(url, options)
      .pipe(
        tap({
          error: (err) => {
            console.error("Error fetching admin expenses:", err);
          },
        }),
      );
  }

  getExpensesSupervisor(
    supervisorId: string,
    page: number = 1,
    limit: number = 10,
    search: string = "",
    fromDate?: string,
    toDate?: string,
  ): Observable<{ status: any; message: any; data: any; pagination?: any }> {
    const url = `${environment.domain}/manageExpense/getExpensesSupervisor`;

    let params = new HttpParams()
      .set("supervisorId", supervisorId)
      .set("page", page.toString())
      .set("limit", limit.toString());

    if (search) {
      params = params.set("search", search);
    }

    if (fromDate) {
      params = params.set("fromDate", fromDate);
    }

    if (toDate) {
      params = params.set("toDate", toDate);
    }

    const options = {
      headers: this.getHeader(),
      params,
    };

    return this.http
      .get<{
        status: any;
        message: any;
        data: any;
        pagination?: any;
      }>(url, options)
      .pipe(
        tap({
          error: (err) => {
            console.error("Error fetching supervisor expenses:", err);
          },
        }),
      );
  }

  createTransporter(
    form,
  ): Observable<{ status: any; message: any; data: any }> {
    const url = `${environment.domain}/transporter/create`;
    let option = { headers: this.getHeader() };

    return this.http
      .post<{ status: any; message: any; data: any }>(url, form, option)
      .pipe(
        tap({
          next: () => { },
          error: () => { },
          complete: () => { },
        }),
      );
  }

  // UPDATE TRANSPORTER
  updateTransporter(form): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/transporter/update`;
    let option = { headers: this.getHeader() };

    return this.http
      .post<{ status: any; message: any }>(url, form, option)
      .pipe(
        tap({
          next: () => { },
          error: () => { },
          complete: () => { },
        }),
      );
  }

  // DELETE TRANSPORTER
  deleteTransporter(
    transporter_id: any,
  ): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/transporter/delete`;
    let option = { headers: this.getHeader() };

    return this.http
      .post<{ status: any; message: any }>(url, { transporter_id }, option)
      .pipe(
        tap({
          next: () => { },
          error: () => { },
          complete: () => { },
        }),
      );
  }

  // GET ALL TRANSPORTERS
  getAllTransporters(
    page: number = 1,
    limit: number = 20,
    search: string = "",
  ): Observable<{ status: any; data: any; pagination?: any }> {
    const url = `${environment.domain}/transporter/list`;

    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("limit", limit.toString());
    if (search) params.append("search", search);

    let option = { headers: this.getHeader() };

    return this.http
      .get<{
        status: any;
        data: any;
        pagination?: any;
      }>(`${url}?${params.toString()}`, option)
      .pipe(
        tap({
          next: () => { },
          error: (error) => {
            console.error("Error fetching transporters:", error);
          },
          complete: () => { },
        }),
      );
  }

  getTransporterById(id: string) {
    const url = `${environment.domain}/transporter/get/${id}`;
    return this.http.get<{ status: any; message: any; data: any }>(url, {
      headers: this.getHeader(),
    });
  }

  // Get transporters for dropdown (Only _id + full_name)
  getTransportersDropdownList(): Observable<{ status: any; data: any }> {
    const url = `${environment.domain}/transporter/all`;
    let option = { headers: this.getHeader() };

    return this.http.get<{ status: any; data: any }>(url, option).pipe(
      tap({
        next: () => { },
        error: (error) => {
          console.error("Error fetching transporter dropdown list:", error);
        },
        complete: () => { },
      }),
    );
  }

  exportLrs(
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ): Observable<any> {
    let url = `${environment.domain}/lr/exportlrs?search=${encodeURIComponent(
      search,
    )}`;

    if (fromDate) url += `&fromDate=${encodeURIComponent(fromDate)}`;
    if (toDate) url += `&toDate=${encodeURIComponent(toDate)}`;

    return this.http.get(url, {
      headers: this.getHeader(),
    });
  }

  exportTrackers(search = "", fromDate = "", toDate = "") {
    let url = `${environment.domain
      }/lr/exporttrackers?search=${encodeURIComponent(search)}`;

    if (fromDate) url += `&fromDate=${encodeURIComponent(fromDate)}`;
    if (toDate) url += `&toDate=${encodeURIComponent(toDate)}`;

    return this.http.get(url, { headers: this.getHeader() });
  }

  deleteLR(id: string): Observable<{ status: boolean; message: string }> {
    const url = `${environment.domain}/lr/delete-lr/${id}`;
    const options = { headers: this.getHeader() };

    return this.http
      .post<{ status: boolean; message: string }>(url, {}, options)
      .pipe(
        tap({
          next: () => { },
          error: () => { },
          complete: () => { },
        }),
      );
  }

  checkManualLR(
    manualLRNo: string,
    excludeId?: string,
  ): Observable<{ status: boolean; exists: boolean; message: string }> {
    const url = excludeId
      ? `${environment.domain}/lr/check-manual-lr/${manualLRNo}?excludeId=${excludeId}`
      : `${environment.domain}/lr/check-manual-lr/${manualLRNo}`;

    const options = { headers: this.getHeader() };

    return this.http
      .get<{ status: boolean; exists: boolean; message: string }>(url, options)
      .pipe(
        tap({
          next: () => { },
          error: () => { },
          complete: () => { },
        }),
      );
  }

  exportDispenseAdmin(search: string, fromDate: string, toDate: string) {
    const params: any = { search, fromDate, toDate };
    return this.http.get(`${this.baseUrl}/manageExpense/exportDispenseAdmin`, {
      headers: this.getHeader(),
      params,
    });
  }

  exportDispenseSupervisor(
    supervisorId: string,
    search: string,
    fromDate: string,
    toDate: string,
  ) {
    const params: any = { supervisorId, search, fromDate, toDate };
    return this.http.get(
      `${this.baseUrl}/manageExpense/exportDispenseSupervisor`,
      {
        headers: this.getHeader(),
        params,
      },
    );
  }

  //----------------- V2 Dashboard -------------------
  getMonthlyTotalExpenseByYear(year: number) {
    const params: any = { year };

    return this.http.get(
      `${this.baseUrl}/mydashboard/v2/dispense/monthly-total-by-year`,
      {
        headers: this.getHeader(),
        params,
      },
    );
  }
  getMonthlyDispenseBySupervisor(year: number, month: number) {
    const params: any = { year, month };

    return this.http.get(
      `${this.baseUrl}/mydashboard/v2/dispense/monthly-total-by-supervisor`,
      {
        headers: this.getHeader(),
        params,
      },
    );
  }

  getDateWiseCashDispense(year: number, month: number, supervisorId: string) {
    const params: any = {
      year,
      month,
      supervisorId,
    };

    return this.http.get(`${this.baseUrl}/mydashboard/v2/dispense/date-wise`, {
      headers: this.getHeader(),
      params,
    });
  }

  getLRsBySupervisorCompanyMonth(
    supervisorId: string,
    companyId: string,
    month: number,
    year: number,
    type: string = "LR",
  ): Observable<{ status: boolean; message: string; data: any[] }> {
    const url =
      `${environment.domain}/mydashboard/v2/getLRsBySupervisorCompanyMonth/` +
      `${supervisorId}/${companyId}/${month}/${year}?type=${type}`;

    const options = { headers: this.getHeader() };

    return this.http.get<{ status: boolean; message: string; data: any[] }>(
      url,
      options,
    );
  }

  getCashSummaryYearWise(year: number): Observable<{
    status: boolean;
    message: string;
    data: {
      year: number;
      totalCashDispense: number;
      totalCashExpense: number;
      totalUncountedCash: number;
    };
  }> {
    const url = `${environment.domain}/mydashboard/v2/getCashSummaryYearWise/${year}`;
    const options = { headers: this.getHeader() };

    return this.http.get<{
      status: boolean;
      message: string;
      data: {
        year: number;
        totalCashDispense: number;
        totalCashExpense: number;
        totalUncountedCash: number;
      };
    }>(url, options);
  }

  getGeneralExpenseMonthWise(year: number): Observable<{
    status: boolean;
    message: string;
    data: { year: number; month: number; amount: number }[];
  }> {
    const url = `${environment.domain}/mydashboard/v2/general-expense/month-wise`;
    const options = {
      headers: this.getHeader(),
      params: { year: year.toString() },
    };

    return this.http.get<{
      status: boolean;
      message: string;
      data: { year: number; month: number; amount: number }[];
    }>(url, options);
  }

  monthlyGeneralCashExpenseByMonthAndYear(
    year: number,
    month: number,
  ): Observable<{
    status: boolean;
    message: string;
    data: {
      year: number;
      month: number;
      companyName: string;
      supervisorName: string;
      categoryName: string;
      amount: number;
    }[];
  }> {
    const url = `${environment.domain}/mydashboard/v2/monthlyGeneralCashExpenseByMonthAndYear/${year}/${month}`;
    const options = { headers: this.getHeader() };

    return this.http.get<{
      status: boolean;
      message: string;
      data: any[];
    }>(url, options);
  }

  dateWiseGeneralExpense(
    year: number,
    month: number,
    companyId: string,
    supervisorId: string,
  ) {
    return this.http.get(
      `${environment.domain}/mydashboard/v2/dateWiseGeneralExpense/${year}/${month}/${companyId}/${supervisorId}`,
      { headers: this.getHeader() },
    );
  }

  getVehicleDashboardSummary() {
    const url = `${environment.domain}/mydashboard/v2/vehicleSummary`;

    return this.http.get<{
      status: boolean;
      message: string;
      data: {
        totalVehicles: number;
        documentsExpired: number;
      };
    }>(url, {
      headers: this.getHeader(),
    });
  }

  getExpiredVehicles() {
    const url = `${environment.domain}/mydashboard/v2/expiredVehicles`;
    return this.http.get<any>(url, {
      headers: this.getHeader(),
    });
  }

  //----------------- V2 Dashboard -------------------

  //----------------- Employee Management -------------------

  createEmployee(data: FormData): Observable<any> {
    const url = `${environment.domain}/employee/create`;

    return this.http.post<any>(url, data, {
      headers: this.getHeader(),
    });
  }

  updateEmployee(data: any): Observable<{
    status: boolean;
    message: string;
  }> {
    const url = `${environment.domain}/employee/update`;
    return this.http.post<any>(url, data, {
      headers: this.getHeader(),
    });
  }

  deleteEmployee(data: { id: string }): Observable<{
    status: boolean;
    message: string;
  }> {
    const url = `${environment.domain}/employee/delete`;
    return this.http.post<any>(url, data, {
      headers: this.getHeader(),
    });
  }

  restoreEmployee(data: { id: string }): Observable<{
    status: boolean;
    message: string;
  }> {
    const url = `${environment.domain}/employee/restore`;
    return this.http.post<any>(url, data, {
      headers: this.getHeader(),
    });
  }

  getAllEmployees(params: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
  }): Observable<any> {
    const url = `${environment.domain}/employee/list`;
    return this.http.get(url, {
      headers: this.getHeader(),
      params: {
        page: params.page || 1,
        limit: params.limit || 10,
        search: params.search || "",
        status: params.status || "",
      },
    });
  }

  getEmployeesDropdown(): Observable<{
    status: boolean;
    data: {
      _id: string;
      name: string;
    }[];
  }> {
    const url = `${environment.domain}/employee/all`;
    return this.http.get<any>(url, {
      headers: this.getHeader(),
    });
  }

  getEmployeeById(id: string): Observable<{
    status: boolean;
    message: string;
    data: any;
  }> {
    const url = `${environment.domain}/employee/get/${id}`;
    return this.http.get<any>(url, {
      headers: this.getHeader(),
    });
  }

  addMonthlyBalance(payload: {
    year: number;
    month: number;
    amount: number;
    remarks?: string;
  }): Observable<{
    status: boolean;
    message: string;
  }> {
    const url = `${environment.domain}/manageExpense/addMonthlyBalance`;
    return this.http.post<any>(url, payload, {
      headers: this.getHeader(),
    });
  }

  updateMonthlyBalance(payload: {
    year: number;
    month: number;
    amount: number;
    remarks?: string;
  }): Observable<{
    status: boolean;
    message: string;
  }> {
    const url = `${environment.domain}/manageExpense/updateMonthlyBalance`;
    return this.http.post<any>(url, payload, {
      headers: this.getHeader(),
    });
  }

  addMoreBalance(payload: {
    year: number;
    month: number;
    amount: number;
    remarks?: string;
  }): Observable<{
    status: boolean;
    message: string;
  }> {
    const url = `${environment.domain}/manageExpense/addMoreBalance`;
    return this.http.post<any>(url, payload, {
      headers: this.getHeader(),
    });
  }

  getDispenseHistory(params: {
    year?: number;
    month?: number;
    companyId?: string;
    supervisorId?: string;
  }): Observable<{
    status: boolean;
    data: any[];
  }> {
    let queryParams = "";

    if (params.year) queryParams += `year=${params.year}&`;
    if (params.month) queryParams += `month=${params.month}&`;
    if (params.companyId) queryParams += `companyId=${params.companyId}&`;
    if (params.supervisorId)
      queryParams += `supervisorId=${params.supervisorId}&`;

    const url = `${environment.domain}/manageExpense/dispenseHistory?${queryParams}`;

    return this.http.get<any>(url, {
      headers: this.getHeader(),
    });
  }

  getMonthlyCashStats(
    year: number,
    month: number,
  ): Observable<{
    status: boolean;
    data: {
      monthLabel: string;
      totalAmount: number;
      usedAmount: number;
      remainingAmount: number;
      usedPercentage: number;
    };
  }> {
    const url = `${environment.domain}/manageExpense/monthlyCashStats?year=${year}&month=${month}`;

    return this.http.get<any>(url, {
      headers: this.getHeader(),
    });
  }

  // temporry - above is the real logic
  getMonthlyUsedCash(
    year: number,
    month: number,
  ): Observable<{
    status: boolean;
    data: any;
  }> {
    const url = `${environment.domain}/manageExpense/monthlyUsedCash?year=${year}&month=${month}`;

    return this.http.get<any>(url);
  }
  getTopupHistory(
    year: number,
    month: number,
  ): Observable<{
    status: boolean;
    data: {
      year: number;
      month: number;
      monthLabel: string;
      history: {
        action: "ADD" | "UPDATE";
        amountChanged: number;
        previousTotalAmount: number;
        newTotalAmount: number;
        remarks: string;
        updatedAt: string;
        updatedBy: {
          _id: string;
          name: string;
          email: string;
        } | null;
      }[];
    };
  }> {
    const url = `${environment.domain}/manageExpense/topupHistory?year=${year}&month=${month}`;

    return this.http.get<any>(url, {
      headers: this.getHeader(),
    });
  }

  exportClients(
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ): Observable<any> {
    let url = `${environment.domain
      }/manageClient/exportclients?search=${encodeURIComponent(search)}`;

    if (fromDate) url += `&fromDate=${encodeURIComponent(fromDate)}`;
    if (toDate) url += `&toDate=${encodeURIComponent(toDate)}`;

    return this.http.get(url, {
      headers: this.getHeader(),
    });
  }

  exportDrivers(
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ): Observable<any> {
    let url = `${environment.domain
      }/manageDriver/exportdrivers?search=${encodeURIComponent(search)}`;

    if (fromDate) url += `&fromDate=${encodeURIComponent(fromDate)}`;
    if (toDate) url += `&toDate=${encodeURIComponent(toDate)}`;

    return this.http.get(url, {
      headers: this.getHeader(),
    });
  }

  exportVehicles(
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ): Observable<any> {
    let url = `${environment.domain
      }/manageVehicle/exportVehicle?search=${encodeURIComponent(search)}`;

    if (fromDate) url += `&fromDate=${encodeURIComponent(fromDate)}`;
    if (toDate) url += `&toDate=${encodeURIComponent(toDate)}`;

    return this.http.get(url, {
      headers: this.getHeader(),
    });
  }

  /**--------------------------Manage expense v2------------------------------*/
  getExpensesByCategory(
    expenseCategory: string,
    search: string = "",
    page: number = 1,
    limit: number = 10,
    fromDate: string = "",
    toDate: string = "",
  ): Observable<any> {
    let url = `${environment.domain
      }/manageExpense/v2/getExpensesByCategory?expenseCategory=${encodeURIComponent(
        expenseCategory,
      )}`;

    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (page) url += `&page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (fromDate) url += `&fromDate=${encodeURIComponent(fromDate)}`;
    if (toDate) url += `&toDate=${encodeURIComponent(toDate)}`;

    return this.http.get(url, {
      headers: this.getHeader(),
    });
  }

  exportExpensesByCategory(
    expenseCategory: string,
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ): Observable<any> {
    let params = new HttpParams().set("expenseCategory", expenseCategory);

    if (search) {
      params = params.set("search", search);
    }

    if (fromDate && toDate) {
      params = params.set("fromDate", fromDate).set("toDate", toDate);
    }

    return this.http.get(
      `${this.baseUrl}/manageExpense/v2/exportExpensesByCategory`,
      {
        params,
        headers: this.getHeader(),
      },
    );
  }
  /**--------------------------Manage expense v2------------------------------*/

  // Own vehicle

  getOwnVehicleDropdown(): Observable<{
    status: boolean;
    message: string;
    data: {
      _id: string;
      vehicle_no: string;
      type: string;
    }[];
  }> {
    const url = `${environment.domain}/ownVehicle/getOwnVehicleList`;
    return this.http.get<any>(url, {
      headers: this.getHeader(),
    });
  }

  getVehicleTypeDropdown(): Observable<{
    status: boolean;
    message: string;
    data: {
      _id: string;
      vehicletype_name: string;
    }[];
  }> {
    const url = `${environment.domain}/ownVehicle/getAllVehicleTypeList`;
    return this.http.get<any>(url, {
      headers: this.getHeader(),
    });
  }

  getOwnVehicleExpenseList(
    page: number = 1,
    limit: number = 10,
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ) {
    const params: any = {
      page: page.toString(),
      limit: limit.toString(),
    };

    if (search) params.search = search;
    if (fromDate) params.from = fromDate;
    if (toDate) params.to = toDate;

    return this.http.get<any>(`${this.baseUrl}/ownVehicle/get`, {
      params,
      headers: this.getHeader(),
    });
  }

  getParticularOwnVehicleExpense(expenseId: string): Observable<{
    status: boolean;
    message: string;
    data: any;
  }> {
    const url = `${environment.domain}/ownVehicle/getById`;
    return this.http.get<any>(url, {
      headers: this.getHeader(),
      params: {
        _id: expenseId,
      },
    });
  }

  addOwnVehicleExpense(formData: FormData) {
    return this.http.post<any>(
      `${environment.domain}/ownVehicle/add`,
      formData,
    );
  }

  updateOwnVehicleExpense(formData: FormData) {
    return this.http.post<any>(
      `${environment.domain}/ownVehicle/update`,
      formData,
    );
  }

  deleteOwnVehicleExpense(expenseId: string): Observable<{
    status: boolean;
    message: string;
  }> {
    const url = `${environment.domain}/ownVehicle/delete`;
    return this.http.post<any>(
      url,
      { _id: expenseId },
      {
        headers: this.getHeader(),
      },
    );
  }

  exportOwnVehicleExpense(
    search: string = "",
    fromDate: string = "",
    toDate: string = "",
  ) {
    const params: any = {};

    if (search) params.search = search;
    if (fromDate) params.from = fromDate;
    if (toDate) params.to = toDate;

    return this.http.get(`${this.baseUrl}/ownVehicle/export`, {
      headers: this.getHeader(),
      params,
    });
  }

  //------------------ temporary -------------------

  createDispenseDerived({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpense/createDispenseDerived`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }
  updateDispenseDerived({ form }): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpense/updateDispenseDerived`;
    let option = { headers: this.getHeader() };
    return this.http
      .post<{ status: any; message: any }>(url, { form }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  deleteDispenseDerived(_id): Observable<{ status: any; message: any }> {
    const url = `${environment.domain}/manageExpense/deleteDispenseDerived`;

    let option = { headers: this.getHeader() };
    // console.log("email", _id);

    return this.http
      .post<{ status: any; message: any }>(url, { _id }, option)
      .pipe(
        tap({
          next: (val: { status: any; message: any }) => { },
          error: (error) => { },
          complete: () => { },
        }),
      );
  }

  getVehiclesOfTransporter(
    transporterId: string,
  ): Observable<{ status: any; message?: any; data: any }> {
    const url = `${environment.domain}/transporter/${transporterId}/vehicles`;

    const option = {
      headers: this.getHeader(),
    };

    return this.http
      .get<{ status: any; message?: any; data: any }>(url, option)
      .pipe(
        tap({
          next: () => { },
          error: () => { },
          complete: () => { },
        }),
      );
  }

  getPaymentLedger(page: number = 1): Observable<any> {
    return this.http.get(`${this.baseUrl}/payment-ledger/v2/?page=${page}`, { headers: this.getHeader() });
  }

  getPaymentLedgerByClient(clientId: string, page: number = 1): Observable<any> {
    return this.http.get(`${this.baseUrl}/payment-ledger/v2/organized-by-company?client=${clientId}&page=${page}`, { headers: this.getHeader() });
  }

  getOrganizedPaymentLedger(page: number = 1): Observable<any> {
    return this.http.get(`${this.baseUrl}/payment-ledger/v2/all-organized?page=${page}`, { headers: this.getHeader() });
  }

  searchPaymentLedgerByClient(clientName: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/payment-ledger/v2/search-by-client?clientName=${encodeURIComponent(clientName)}`, { headers: this.getHeader() });
  }

  getPaymentLedgerById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/payment-ledger/${id}`, { headers: this.getHeader() });
  }

  getPaymentLedgerRecords(parentId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/payment-ledger/v2/record/parent/${parentId}`, { headers: this.getHeader() });
  }

  getPaymentLedgerRecordById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/payment-ledger/v2/record/${id}`, { headers: this.getHeader() });
  }

  addPaymentLedgerRecord(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/payment-ledger/v2/record/`, formData, { headers: this.getHeader() });
  }

  updatePaymentLedgerRecord(id: string, formData: FormData): Observable<any> {
    return this.http.put(`${this.baseUrl}/payment-ledger/v2/record/${id}`, formData, { headers: this.getHeader() });
  }

  exportPaymentLedgerExcel(id: string = 'all'): Observable<Blob> {
    const endpoint = id && id !== 'all'
      ? `${this.baseUrl}/payment-ledger/v2/export/${id}`
      : `${this.baseUrl}/payment-ledger/v2/export`;
    return this.http.get(endpoint, {
      headers: this.getHeader(),
      responseType: 'blob',
    });
  }
}
